import React, { FC } from 'react'
import Box from '@mui/material/Box'
import { Gateway, Sensor } from 'src/api'
import { SensorColumnsDataGrid } from 'src/components/columns/sensor'
import { CommonSensorList } from '../sensor/sensorList/commonSensorsList'

const columns = [
  SensorColumnsDataGrid.Id(),
  SensorColumnsDataGrid.LastActiveContractor,
  SensorColumnsDataGrid.Project,
  SensorColumnsDataGrid.ProjectSection,
  SensorColumnsDataGrid.LastPing
]

interface GatewaySensorsProps {
  gateway: Gateway
}

export const GatewaySensors: FC<GatewaySensorsProps> = ({ gateway }) => {
  const sensors: Sensor[] = gateway.sensors || []

  return (
    <Box height="500px">
      <CommonSensorList columns={columns} count={sensors.length} data={sensors} isLoading={false} exportedFileName={`${document.title}_sensors`} />
    </Box>
  )
}
